<template>
  <div class="custom-field-timestamp flex-1 align-baseline">
    <div class="component-item">
      <date-picker
        v-model="customDate"
        field-min-width="175px"
        :placeholder="t('customFields.select_date')"
        :test-id="`${toKebabCase(field.label)}-date-picker`"
        compact-display
        :display-field-label="false"
        :display-field-icon="false"
        :required="field.required"></date-picker>
    </div>
    <div class="component-item">
      <time-entry
        :test-id="`${toKebabCase(field.label)}-time-entry`"
        :date="dateTime"
        :warehouse="warehouse"
        v-model="customTime"
        :fontSizeLarge="false"
        :required="field.required"
        :compact="isMobile()"
        inline></time-entry>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';

import customFieldTypeMixinOld from '@/modules/custom_fields/mixins/customFieldTypeMixinOld';
import { DateTimeFormats, t, toKebabCase } from '@nova/core';
import { isMobile } from '@satellite/plugins/util';

export default {
  name: 'custom-field-timestamp-old',
  mixins: [customFieldTypeMixinOld],
  props: {
    warehouse: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      customTime: {
        amPm: '',
        time: ''
      },
      customDate: ''
    };
  },
  computed: {
    dateTime() {
      const newDateTimeString = [this.customDate, this.customTime.time, this.customTime.amPm].join(
        ' '
      );
      const newDateTime = moment.tz(
        newDateTimeString,
        `${DateTimeFormats.DateDashed} ${DateTimeFormats.Extended12HrTimeLeadingZeroHour} a`,
        this.warehouse.timezone
      );
      return newDateTime?.isValid() ? newDateTime : null;
    }
  },
  methods: {
    t,
    toKebabCase,
    isMobile,
    emitValueUpdate(value) {
      if (this.field.required && !value) {
        return null;
      }
      this.$emit('update:model-value', this.dateTime);
    }
  },
  beforeMount() {
    if (this.value) {
      const currentDate = moment.tz(this.value, this.warehouse.timezone);

      if (currentDate?.isValid()) {
        this.customDate = currentDate.format(DateTimeFormats.DateDashed);
        this.customTime.time = currentDate.format(DateTimeFormats.Extended12HrTimeLeadingZeroHour);
        this.customTime.amPm = currentDate.format(DateTimeFormats.AmPm);
      }
    }
  },
  watch: {
    value() {
      return false;
    },
    customDate(value) {
      this.emitValueUpdate(value);
    },
    customTime(value) {
      this.emitValueUpdate(value);
    }
  }
};
</script>
<style lang="scss">
.custom-field-timestamp {
  display: flex;
  gap: 1rem;
}
.is-mobile {
  .custom-field-timestamp {
    display: block;
    .component-item {
      margin-bottom: 5px !important;
      .v-input,
      .v-input-control {
        margin: 0 !important;
        padding-top: 5px !important;
        align-items: flex-start !important;
      }
    }
  }
}
</style>
